import EnergyOverview from '../EnergyOverview/lang/es.json'
import WForecast from '../WeatherForecast/lang/es.json'

export const es = {
  ...EnergyOverview,
  ...WForecast
};  